import { extend } from '@syncfusion/ej2-base'
import { useMemo, useRef } from 'react'
import { type FingerprintableEvent, fingerprintScheduleEvent } from './fingerprintScheduleEvent'

const fingerprintEvents = (events: FingerprintableEvent[]): string =>
  events.map(fingerprintScheduleEvent).join(';')

export const useStableScheduleDataSource = <T extends FingerprintableEvent>(events: T[]): T[] => {
  const dataRef = useRef<T[]>([])
  const fingerprintRef = useRef('')

  return useMemo(() => {
    const fingerprint = fingerprintEvents(events)
    if (fingerprint === fingerprintRef.current) {
      return dataRef.current
    }

    fingerprintRef.current = fingerprint
    const next = extend([], events, null, true) as T[]
    dataRef.current = next
    return next
  }, [events])
}
